import {
    style,
    selectorStyle,
} from '@kurtosys/ksys-portal-components/build/utils/propStyles';

export const textOverflow = style({
    prop: 'textOverflow',
    cssProperty: 'text-overflow',
});

export const verticalAlign = style({
    prop: 'verticalAlign',
    cssProperty: 'vertical-align',
});

export const whiteSpace = style({
    prop: 'whiteSpace',
    cssProperty: 'white-space',
});

export const top = style({
    prop: 'top',
    cssProperty: 'top',
});

export const opacity = style({
    prop: 'opacity',
    cssProperty: 'opacity',
});

export const tableLayout = style({
    prop: 'tableLayout',
    cssProperty: 'table-layout',
});

export const borderCollapse = style({
    prop: 'borderCollapse',
    cssProperty: 'border-collapse',
});

export const borderSpacing = style({
    prop: 'borderSpacing',
    cssProperty: 'border-spacing',
});

export const isDisabled = selectorStyle({
    prop: 'isDisabled',
    selector: ':disabled',
});



// WEBPACK FOOTER //
// ./src/utils/customPropStyles.ts